import { LoanEventType, PaginatedGetParams } from '@api';
import { PaginatedResponse } from '@tsp-ui/core';

import { apiUtils, getAccountBaseUrl } from '../api-utils';


export interface LoanActivity {
    id: string;
    loanId: string;
    loanNumber: string;
    customerId?: string;
    date: string;
    type: LoanEventType;
    userId: string;
}

/**
 * Gets most recent 10 loan activities for a client or customer
 */
export function getLoanActivity(
    clientId: string, customerId?: string, params?: PaginatedGetParams
): Promise<PaginatedResponse<LoanActivity>> {
    return apiUtils.get(`${getAccountBaseUrl(clientId, customerId)}/loan-activity`, params);
}
